export type PkLiveCategoryId =
  | 'all'
  | 'new'
  | 'cricket'
  | 'indian'
  | 'featured'
  | 'top_rated'
  | 'roulette'
  | 'teen'
  | 'tiger'
  | 'andar'
  | 'baccarat'
  | 'blackjack'
  | 'poker'
  | 'arcade'
  | 'crash'

export type PkLiveProviderId =
  | 'all'
  | 'winmatch'
  | 'ezugi'
  | 'evolution'
  | 'xpg'
  | 'playtech'
  | 'tvbet'
  | 'bgames'
  | '7mojos'
  | 'vivo'
  | 'jacktop'
  | 'alg'
  | 'elcasino'
  | 'everest'
  | 'iconic21'
  | 'luckystreak'

export const PK_LC_BANNERS = [
  { src: '/imgs/playkaro/live-casino/banners/winmatch.webp', alt: 'Winmatch' },
  { src: '/imgs/playkaro/live-casino/banners/cricket.webp', alt: 'Cricket' },
  { src: '/imgs/playkaro/live-casino/banners/777.webp', alt: '777' },
  { src: '/imgs/playkaro/live-casino/banners/playtech.webp', alt: 'Playtech' },
  { src: '/imgs/playkaro/live-casino/banners/ez_marble_race.webp', alt: 'Marble Race' },
  { src: '/imgs/playkaro/live-casino/banners/elcasino.webp', alt: 'Elcasino' },
  { src: '/imgs/playkaro/live-casino/banners/claw_roulette.webp', alt: 'Claw Roulette' },
] as const

export const PK_LC_CATEGORIES: Array<{ id: PkLiveCategoryId; label: string; rx?: RegExp }> = [
  { id: 'all', label: 'All' },
  { id: 'new', label: 'New' },
  { id: 'cricket', label: 'Cricket', rx: /cricket/i },
  { id: 'indian', label: 'Indian', rx: /teen\s?patti|andar|bahar|dragon\s?tiger|indian|jhandi|matka/i },
  { id: 'featured', label: 'Featured' },
  { id: 'top_rated', label: 'Top Rated' },
  { id: 'roulette', label: 'Roulette', rx: /roulette|rulet|roleta/i },
  { id: 'teen', label: 'Teen Patti', rx: /teen\s?patti|teenpatti|3\s?patti|3patti/i },
  { id: 'tiger', label: 'Dragon Tiger', rx: /dragon\s?tiger/i },
  { id: 'andar', label: 'Andar bahar', rx: /andar\s?bahar|andarbahar/i },
  { id: 'baccarat', label: 'Baccarat', rx: /baccarat|bac\s?bo/i },
  { id: 'blackjack', label: 'Blackjack', rx: /black\s?jack|blackjack|\b21\b/i },
  { id: 'poker', label: 'Poker', rx: /poker|hold\s?em|holdem|texas/i },
  { id: 'arcade', label: 'Arcade', rx: /arcade|marble|claw|crash|aviator|mines|plinko/i },
  { id: 'crash', label: 'Crash Game', rx: /crash|aviator|jetx|spribe|limbo/i },
]

export const PK_LC_PROVIDERS: Array<{ id: PkLiveProviderId; label: string; icon?: string; rx?: RegExp }> = [
  { id: 'all', label: 'ALL', icon: '/imgs/playkaro/live-casino/providers/all.webp' },
  { id: 'winmatch', label: 'WINMATCH', icon: '/imgs/playkaro/live-casino/providers/winmatch.png', rx: /winmatch|royaljeet/i },
  { id: 'ezugi', label: 'EZUGI', icon: '/imgs/playkaro/live-casino/providers/ezugi.png', rx: /ezugi/i },
  { id: 'evolution', label: 'EVOLUTION', icon: '/imgs/playkaro/live-casino/providers/evolution.png', rx: /evolution/i },
  { id: 'xpg', label: 'XPG', icon: '/imgs/playkaro/live-casino/providers/xpg.png', rx: /xpg|xpro/i },
  { id: 'playtech', label: 'PLAYTECH', icon: '/imgs/playkaro/live-casino/providers/playtech.png', rx: /playtech/i },
  { id: 'tvbet', label: 'TVBET', icon: '/imgs/playkaro/live-casino/providers/tvbet.png', rx: /tvbet|tv\s?bet/i },
  { id: 'bgames', label: 'BGAMES', icon: '/imgs/playkaro/live-casino/providers/bgames.png', rx: /bgames|bgaming|b\s?games/i },
  { id: '7mojos', label: '7MOJOS', icon: '/imgs/playkaro/live-casino/providers/7mojos.png', rx: /7\s?mojos|mojos/i },
  { id: 'vivo', label: 'VIVO', icon: '/imgs/playkaro/live-casino/providers/vivo.png', rx: /vivo/i },
  { id: 'jacktop', label: 'JACKTOP', icon: '/imgs/playkaro/live-casino/providers/jacktop.png', rx: /jacktop/i },
  { id: 'alg', label: 'ALG', icon: '/imgs/playkaro/live-casino/providers/alg.png', rx: /\balg\b|absolute/i },
  { id: 'elcasino', label: 'ELCASINO', icon: '/imgs/playkaro/live-casino/providers/elcasino.png', rx: /elcasino|el\s?casino/i },
  { id: 'everest', label: 'EVEREST', icon: '/imgs/playkaro/live-casino/providers/everest.png', rx: /everest/i },
  { id: 'iconic21', label: 'ICONIC21', icon: '/imgs/playkaro/live-casino/providers/iconic21.png', rx: /iconic/i },
  { id: 'luckystreak', label: 'LUCKYSTREAK', icon: '/imgs/playkaro/live-casino/providers/luckystreak.png', rx: /lucky\s?streak/i },
]

export type PkNetwinRow = {
  user: string
  amount: string
  game: string
  when: string
  image: string
}

const NETWIN_IMAGES = [
  '/imgs/playkaro/live-casino/netwin/1.jpeg',
  '/imgs/playkaro/live-casino/netwin/2.jpeg',
  '/imgs/playkaro/live-casino/netwin/3.jpeg',
  '/imgs/playkaro/live-casino/netwin/4.jpeg',
  '/imgs/playkaro/live-casino/netwin/5.jpg',
  '/imgs/playkaro/live-casino/netwin/6.jpeg',
  '/imgs/playkaro/live-casino/netwin/7.jpeg',
  '/imgs/playkaro/live-casino/netwin/8.jpeg',
  '/imgs/playkaro/live-casino/netwin/9.jpeg',
  '/imgs/playkaro/live-casino/netwin/10.jpeg',
  '/imgs/playkaro/live-casino/netwin/11.jpeg',
  '/imgs/playkaro/live-casino/netwin/12.jpeg',
  '/imgs/playkaro/live-casino/netwin/13.jpeg',
]

const NETWIN_SEED: Array<Omit<PkNetwinRow, 'image'>> = [
  { user: 'VEN****', amount: '22249.07', game: 'Appeal Deluxe', when: 'a day ago' },
  { user: 'SAH****', amount: '14036.81', game: 'Jackpot Express', when: 'a day ago' },
  { user: 'PAR****', amount: '46799.36', game: 'Wicked Circus', when: 'a day ago' },
  { user: 'D ****', amount: '42301.25', game: 'Peking Luck', when: 'a day ago' },
  { user: 'SHR****', amount: '5127.84', game: 'Lara Croft', when: 'a day ago' },
  { user: 'PRA****', amount: '47608.67', game: 'Sunset Reels', when: 'a day ago' },
  { user: 'RAJ****', amount: '18920.40', game: 'Royal Roulette', when: '2 hours ago' },
  { user: 'AMI****', amount: '9033.12', game: 'Teen Patti', when: '3 hours ago' },
  { user: 'KIR****', amount: '33110.90', game: 'Andar Bahar', when: '5 hours ago' },
  { user: 'MOH****', amount: '7544.00', game: 'Dragon Tiger', when: '6 hours ago' },
  { user: 'NEH****', amount: '21008.55', game: 'Ice Fishing', when: '8 hours ago' },
  { user: 'VIK****', amount: '12880.22', game: 'Candyball Roulette', when: '10 hours ago' },
  { user: 'SON****', amount: '6402.18', game: 'Space Ball', when: '12 hours ago' },
  { user: 'HAR****', amount: '15590.70', game: 'EZ Dealer Roulette', when: '14 hours ago' },
  { user: 'DIV****', amount: '28811.09', game: 'Baccarat', when: '16 hours ago' },
  { user: 'ARJ****', amount: '4199.50', game: 'Blackjack', when: '18 hours ago' },
  { user: 'POO****', amount: '9901.33', game: 'Marble Race', when: '20 hours ago' },
  { user: 'YAS****', amount: '17220.80', game: 'Power Play Roulette', when: '22 hours ago' },
  { user: 'MAN****', amount: '8344.61', game: 'Chicken Live', when: 'a day ago' },
  { user: 'RIT****', amount: '25010.00', game: 'XproGaming', when: 'a day ago' },
]

export const PK_LC_NETWIN_FALLBACK: PkNetwinRow[] = NETWIN_SEED.map((row, i) => ({
  ...row,
  image: NETWIN_IMAGES[i % NETWIN_IMAGES.length],
}))

export function getGameSearchText(game: Record<string, unknown>): string {
  return [
    game.game_name,
    game.game_group,
    game.game_category,
    game.live_category,
    game.provider,
    game.game_provider,
    game.provider_name,
  ]
    .filter(Boolean)
    .join(' ')
}

export function gameMatchesCategory(game: Record<string, unknown>, id: PkLiveCategoryId, index: number): boolean {
  if (id === 'all') return true
  if (id === 'featured' || id === 'top_rated') return index < 24
  if (id === 'new') return index < 16
  const found = PK_LC_CATEGORIES.find((c) => c.id === id)
  return found?.rx ? found.rx.test(getGameSearchText(game)) : true
}

export function gameMatchesProvider(game: Record<string, unknown>, id: string): boolean {
  if (id === 'all') return true
  const found = PK_LC_PROVIDERS.find((p) => p.id === id)
  const text = getGameSearchText(game)
  if (found?.rx) return found.rx.test(text)
  const compact = (value: unknown) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '')
  return compact(text).includes(id) || compact(game.game_provider) === id || compact(game.provider) === id
}

export function maskWinnerName(name: string): string {
  const raw = (name || '').trim()
  if (raw.length <= 3) return `${raw.charAt(0) || 'U'} ****`
  return `${raw.slice(0, 3).toUpperCase()}****`
}
